import urlConditional from "./apiInfo";
const location = urlConditional();
// const location = "https://www.g2g-api.com";

const MembersManager = {
  async getMembers() {
    const resp = await fetch(`${location}/members`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return resp.json();
  },

  async getMembersAdmin({ page, filter}) {
    const resp = await fetch(`${location}/members-admin?page=${page}&filter=${filter}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return resp.json();
  },
};

export default MembersManager;
